
    <div class="ui-{{textDirection}}" dir="{{textDirection}}">
      <app-breadcrumb></app-breadcrumb>
      <router-outlet></router-outlet>
    </div>
  